import React, { useState, useEffect, useRef } from "react";
import { useMountEffect } from 'primereact/hooks';
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import styles from "./Dashboard.module.css";
import { setHasUpdates } from "../common/commonSlice";
import { Card } from "primereact/card";
import { getDashboardData, setPendingLeaves } from "./dashboardSlice";
import moment from "moment";
import { Responsive, WidthProvider } from "react-grid-layout";
import VcompParticipateNotification from "../../components/dashboard/Vcomp/VcompParticipateNotification";
import VcompManageNotification from "../../components/dashboard/Vcomp/VcompManageNotification";
import NewsTable from "../../components/dashboard/News/NewsTable";
import { checkPermission } from "../../app/utils/helpers";
import { config } from "../../app/utils/config";
import { getLeaves } from "../leaves/leavesSlice";
import { getCollabs } from "../../components/collabs/collabsSlice";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

export function DashboardView() {

    const dispatch = useDispatch()
    const [selectedNews, setSelectedNews] = useState(null)
    const newsList = useSelector((state) => state.dashboard.news)
    const dashboardItems = useSelector((state) => state.dashboard.items)
    const notifications = useRef(null)
    const mounted = useRef(null)
    const lastNewsId = useSelector((state) => state.dashboard.lastNewsId)

    const leaves = useSelector((state) => state.leaves.list)
    const pendingLeaves = useSelector((state) => state.dashboard.pendingLeaves)
    const collabs = useSelector((state) => state.collabs.currentList)
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)

    function loadLeaves() {
        console.log(selectedTeamsIds, collabs)
        if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
            let selectedCollabsIds = collabs.reduce((array, current) => {
                array.push(current.id)
                return array
            }, [])
            dispatch(getLeaves({ selectedTeamsIds, selectedCollabsIds }))
        }
    }
    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
            const boolHasUpdates = Boolean(newsList?.some(item => item.seen === null))
            dispatch(setHasUpdates(boolHasUpdates))
            dispatch(getDashboardData({ lastNewsId: lastNewsId }))
            loadLeaves()
        }
    }, [])
    
    useEffect(() => {
        if (selectedTeamsIds && selectedTeamsIds.length) {
            dispatch(getCollabs({ selectedTeamsIds, isCurrent: true }))
        }
    }, [dispatch, selectedTeamsIds])

    useEffect(() => {
        loadLeaves()
    }, [selectedTeamsIds, collabs])

    useEffect(() => {
        const boolHasUpdates = Boolean(newsList?.some(item => item.seen === null))
        dispatch(setHasUpdates(boolHasUpdates))
    }, [newsList])

    useEffect(() => {
        if (leaves) {
            const pendingLeaves = leaves.filter(leave => leave.status === "PENDING").length;
            dispatch(setPendingLeaves(pendingLeaves));
        }
    }, [leaves])


    useMountEffect(() => {
        if (notifications.current) {
            notifications.current.clear();
            notifications.current.show([
                { sticky: true, severity: 'info', summary: 'Info', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'success', summary: 'Success', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'warn', summary: 'Warning', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'error', summary: 'Error', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'success', summary: 'Success', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'info', summary: 'Info', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'error', summary: 'Error', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'info', summary: 'Info', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'success', summary: 'Success', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'warn', summary: 'Warning', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'error', summary: 'Error', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'success', summary: 'Success', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'info', summary: 'Info', detail: 'Message Content', closable: true },
                { sticky: true, severity: 'error', summary: 'Error', detail: 'Message Content', closable: true },
            ])
        }
    })


    const onNewsSelect = (e) => {
        setSelectedNews(e.data)
    }

    const cardHeader = (label, i) => {
        return <Row className="p-2">
            <Col><h4><Langs str={label} /></h4></Col>
            {/* {i && <Col lg="1" style={{ color: "#4b5563", cursor: "pointer" }} className="d-flex justify-content-end" onClick={() => dispatch(hideDashboardItem(i))}>
                x
            </Col>} */}
        </Row>
    }

    const dateBodyTemplate = (rowData, column) => {
        return moment(rowData[column.field]).format("DD/MM/YYYY HH:mm")
    }

    function renderDashboardComponent(data, key, active) {
        if (!active) return null
        switch (data.type) {
            case "METRIC":
                return <Card key={key} style={{ color: data.color }} header={cardHeader(data.title, key)}>
                    <h3>{data.value}</h3>
                </Card>
            case "LEAVES":
                return <Card key={key} style={{ color: data.color }} header={cardHeader(data.title, key)}>
                    <h3>{pendingLeaves}</h3>
                </Card>
            case "NEWS":
                return <Card key={key}><NewsTable /></Card>
            case "VCOMPPARTICIPATE":
                return <Card key={key}><VcompParticipateNotification /></Card>
            case "VCOMPMANAGE":
                return checkPermission(config.scopes.vcomp, config.permissionTypes.edit) ?
                    <Card key={key}><VcompManageNotification /></Card> : null
            default:
                break;
        }
    }

    let layout = dashboardItems.map(item => {
        return {
            x: item.x,
            y: item.y,
            w: item.w,
            h: item.h,
            i: item.i,
            minW: item.minW,
            minH: item.minH,
            maxW: item.maxW,
            maxH: item.maxH,
        }
    })
    return (
        <div>
            <div className={styles.topMenu}>
                <Row style={{ width: "100vw" }}>
                    <Col lg={3}>
                        <span className="headerTitle">
                            {<Langs str="Dashboard" />}
                        </span>
                    </Col>
                    <Col lg={6} className='d-flex justify-content-center'>
                    </Col>
                    <Col lg={3} className='d-flex justify-content-end'>
                    </Col>
                </Row>
            </div>
            <div className={styles.bodyContainer}>
                <ResponsiveReactGridLayout
                    className="layout"
                    rowHeight={140}
                    cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                    initialLayout={layout}
                    layouts={{ lg: layout, md: layout, sm: layout, xs: layout, xxs: layout }}
                    measureBeforeMount={false}
                    useCSSTransforms={true}
                    isDraggable={false}
                    isResizable={false}
                >
                    {dashboardItems.map(item => renderDashboardComponent(item.data, item.i, item.active))}
                </ResponsiveReactGridLayout>
            </div>
        </div>
    )
}